import React from "react";

const Navbar = ({ fullWidth }) => {
  return (
    <header className="fixed top-0 left-0 w-full z-20">
      <div className={`${fullWidth ? "w-full" : "w-full lg:max-w-[75%]"}`}>
        <div className="bg-white shadow px-5 flex items-center justify-between py-3">
          <img
            src="/Images/SkyLogo.png"
            alt="Siddha Sky Wadala"
            className="w-30 h-10"
            onClick={() => (window.location.href = "/")}
          />

          <div className="hidden md:flex gap-6 font-medium">
            <a href="#overview" className="hover:text-[#1218A6]">
              Overview
            </a>
            <a href="#price" className="hover:text-[#1218A6]">
              Price
            </a>
            <a href="#amenities" className="hover:text-[#1218A6]">
              Amenities
            </a>
            <a href="#gallary" className="hover:text-[#1218A6]">
              Gallery
            </a>
            <a href="#location" className="hover:text-[#1218A6]">
              Location
            </a>
            <a href="#contact" className="hover:text-[#1218A6]">
              Contact
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
